import {
    GroupSharingT,
    UserGroupSummaryT,
    UserSharingT,
} from 'business/definitions';
import { Dispatch, SetStateAction } from 'react';

export const isUserSharing = (
    input: UserSharingT | GroupSharingT,
): input is UserSharingT => {
    return (input as UserSharingT).email !== undefined;
};

export const getUsersOptions = (
    allUsers: string[],
    selectedUsers: UserSharingT[],
): UserSharingT[] => {
    const selectedEmail = selectedUsers.map((user) => user.email);
    return allUsers
        .sort((a, b) => a.localeCompare(b))
        .filter((email) => !selectedEmail.includes(email))
        .map((email) => ({
            key: email,
            email,
            editAccess: false,
        }));
};

export const getUserGroupsOptions = (
    allUserGroups: UserGroupSummaryT[],
    selectedUserGroups: GroupSharingT[],
): GroupSharingT[] => {
    const selectedGroupIds = selectedUserGroups.map(
        (userGroup) => userGroup.groupId,
    );
    return allUserGroups
        .sort((a, b) => a.name.localeCompare(b.name))
        .filter((userGroup) => !selectedGroupIds.includes(userGroup.id))
        .map((userGroup) => ({
            key: userGroup.name,
            groupId: userGroup.id,
            groupName: userGroup.name,
            nbMembers: userGroup.nbMembers,
            editAccess: false,
        }));
};

export const removeUser = (
    key: string | number,
    setSelectedUsers: Dispatch<SetStateAction<UserSharingT[]>>,
) => {
    setSelectedUsers((oldState) =>
        oldState.filter((share) => share.key !== key),
    );
};

export const handleChangeEditAccessOf = (
    value: boolean,
    id: string | number,
    setSelectedUsers: Dispatch<SetStateAction<UserSharingT[]>>,
) => {
    setSelectedUsers((oldState) =>
        oldState.map((sharing) => {
            if (sharing.key === id)
                return {
                    key: sharing.key,
                    email: sharing.email,
                    editAccess: value,
                };
            return sharing;
        }),
    );
};

export const addUsers = (
    newSelectedUsers: UserSharingT[],
    selectedUsers: UserSharingT[],
    setSelectedUsers: Dispatch<SetStateAction<UserSharingT[]>>,
) => {
    const selectedUsersValue = selectedUsers.map((share) => share.key);
    const newShares: UserSharingT[] = [];
    newSelectedUsers.forEach((newUser) => {
        if (!selectedUsersValue.includes(newUser.key)) newShares.push(newUser);
    });
    setSelectedUsers([...selectedUsers, ...newShares]);
};
